import { useEffect } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { isFunction } from 'lodash';

import { LOW_PRIORITY } from 'components/root/Container/Layout/Tasks/Task/taskConstants';

import './TaskPrioritySelector.scss';

export default function TaskPrioritySelector({ taskForm, onPriorityChange, taskPriorities = [] }) {
  const hasPriorities = taskPriorities.length > 0;
  const currentPriority = hasPriorities ? taskForm.priority || LOW_PRIORITY : '';

  useEffect(() => {
    if (hasPriorities && !taskForm.priority && isFunction(onPriorityChange)) {
      onPriorityChange(LOW_PRIORITY);
    }
  }, [hasPriorities, onPriorityChange, taskForm.priority]);

  const handleChange = ({ target: { value } }) => {
    isFunction(onPriorityChange) && onPriorityChange(value);
  };

  return (
    <Box className="etc-task-priority">
      <FormControl size="small" fullWidth>
        <InputLabel id="task-priority-label">Priority</InputLabel>
        <Select labelId="task-priority-label" value={currentPriority} label="Priority" onChange={handleChange}>
          {taskPriorities.map(({ priority, name }) => (
            <MenuItem key={priority} value={priority}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
